import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomOurBrandsComponent} from './custom-our-brands.component';
import {CmsConfig, ConfigModule, UrlModule} from '@spartacus/core';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {CustomCarouselModule} from '../../../../spartacus/custom/shared/components/custom-carousel/custom-carousel.module';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';


@NgModule({
  declarations: [CustomOurBrandsComponent],
  exports: [CustomOurBrandsComponent],
  imports: [
    CommonModule, MediaModule, RouterModule, UrlModule,
    CustomCmsItemModule,
    CustomCarouselModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OurBrandsComponent: {
          component: CustomOurBrandsComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomOurBrandsModule { }
